import { v4 as uuid } from 'uuid'

export class Photo {
  // From backend
  id = 0
  file_data:string | null = null
  file_type = ''
  created_at:string = ''

  // Additional fields
  base64 = ''
  base64_sz = ''
  file_name = ''
  loaded = false
  uploaded = true
  uploading = false
  uuid = ''
  
  constructor() {
  }

  public async setViewModelFields()
  {
    if (this.file_data && this.file_type) {
      this.base64 = 'data:' + this.file_type + ';base64,' + this.file_data
      this.base64_sz = this.base64
    }
    if (!this.uuid) {
      this.uuid = uuid();
    }
  }

  static async buildOne(obj: any): Promise<Photo> {
    let target: Photo = Object.assign(new Photo(), obj);
    await target.setViewModelFields();
    return target;
  }

  static async buildMany(objs: any): Promise<Photo[]> {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(await Photo.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

